module.exports = __webpack_public_path__ + "img/fondo_play_icons-orig.ab3bb691.png";